import * as React from "react";

import { Label, Icon } from "../semantic-ui";
import UserLink from "../user/UserLink";
import { GameState, ArmyLabel } from "../board";
import { Color } from "../board/GameState";

const WinnerLabel = ({
  gameWinner,
  color,
}: {
  gameWinner: Color | "draw";
  color: Color;
}) =>
  gameWinner === "draw" ? (
    <Label color="black" title="Draw">
      <Icon name="handshake" fitted />
    </Label>
  ) : gameWinner === color ? (
    <Label color="yellow" title="Winner">
      <Icon name="trophy" fitted style={{ width: 12 }} />
    </Label>
  ) : gameWinner ? (
    <Label color="grey" title="Loser">
      <Icon name="x" fitted style={{ width: 12 }} />
    </Label>
  ) : null;

type Props = {
  game: any;
  gameState: GameState;
  showColorNames: boolean;
};

const PlayerInfo = ({ game, gameState, showColorNames }: Props) => (
  <table>
    <tbody>
      <tr>
        {showColorNames && <th style={{ paddingRight: 15 }}>White:</th>}
        <td>
          <UserLink user={game.white} capitalize />
        </td>
        <td style={{ paddingLeft: 15, whiteSpace: "nowrap" }}>
          <WinnerLabel gameWinner={game.winner} color="white" />
          <ArmyLabel color="white" army={gameState.armies[0]} />
        </td>
      </tr>
      <tr>
        {showColorNames && <th style={{ paddingRight: 15 }}>Black:</th>}
        <td>
          <UserLink user={game.black} capitalize />
        </td>
        <td style={{ paddingLeft: 15, whiteSpace: "nowrap" }}>
          <WinnerLabel gameWinner={game.winner} color="black" />
          <ArmyLabel color="black" army={gameState.armies[1]} />
        </td>
      </tr>
    </tbody>
  </table>
);

PlayerInfo.defaultProps = {
  showColorNames: true,
};

export default PlayerInfo;
